import { getSite } from '@/utils/getSite';
import { ArticleInfo } from '../types/articleInfo';
import { adsSetup, adsTagSetup } from './adsSetup';

export const checkForUserConsentAndGetAdConfig = ({
  articleInfo,
  autostart,
  ypPartId,
  isNativeAd = false,
  isVerticalVideo,
  hideAds,
  hasScrollArticles,
}: {
  articleInfo?: ArticleInfo;
  autostart: string | boolean;
  ypPartId: string | null;
  isNativeAd?: boolean;
  isVerticalVideo?: boolean;
  hideAds?: boolean;
  hasScrollArticles?: boolean;
}): {} => {
  const site = getSite();
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.userConsent) {
      window.userConsent?.isTargetingApproved(async (response: any) => {
        if (response && !isNativeAd && !hideAds) {
          //Targetting is approved here
          try {
            let customAdConfig = {};
            if (site === 'motherhood') {
              customAdConfig = await adsTagSetup({
                autoStart: autostart,
                isVerticalVideo,
                hasScrollArticles,
              });
            } else {
              customAdConfig = await adsSetup({
                articleInfo,
                autoStart: autostart,
                wasYouplay: ypPartId !== null,
                isVerticalVideo,
                hasScrollArticles,
              });
            }
            resolve(customAdConfig);
          } catch {
            resolve({ noConsent: true });
          }
        } else {
          resolve({ noConsent: true });
        }
      });
    } else {
      resolve({ noConsent: true });
    }
  });
};
